import { Navigate, useLocation, useParams } from "react-router-dom";
import { getPublicDealsRetailer, storeGridPathForLegacyDeals } from "../config/publicDeals";
import PublicProductDetailPage from "../pages/PublicProductDetailPage";
import DealRedirectPage from "../pages/DealRedirectPage";
import { getAuthenticatedOnlineDealsPath } from "./PublicDealsRoute.utils";

/**
 * `/deals/:value` predates the public catalog and is also the shared-deal URL.
 * Reserved retailer slugs enter the catalog; every other value keeps the
 * original shared-deal behavior.
 */
export default function PublicDealsRoute({
  authenticated = false,
  retailerSlug,
}: {
  authenticated?: boolean;
  retailerSlug?: string;
}) {
  const { dealId } = useParams<{ dealId: string }>();
  const location = useLocation();
  const retailer = getPublicDealsRetailer(retailerSlug || dealId);

  if (retailer) {
    if (authenticated) {
      return (
        <Navigate
          to={getAuthenticatedOnlineDealsPath(retailer.slug, location.search)!}
          replace
        />
      );
    }
    return <LegacyDealsRedirect retailerSlug={retailer.slug} />;
  }

  return authenticated ? <DealRedirectPage /> : <PublicProductDetailPage />;
}

/** The old guest catalog ("/deals", "/deals/<store>") now lives on the store feed's All deals grid. */
export function LegacyDealsRedirect({ retailerSlug }: { retailerSlug?: string }) {
  const location = useLocation();
  return <Navigate to={storeGridPathForLegacyDeals(retailerSlug, location.search)} replace />;
}
